<template>
  <v-layout pa-1 align-center fill-height fluid row class="controls-layout">
    <v-flex shrink>
      <v-btn
        :disabled='!reportUrl'
        icon
      >
        <a :href="reportUrl" download class="white--text">
          <v-icon large>picture_as_pdf</v-icon>
        </a>
      </v-btn>
    </v-flex>
</v-layout>
</template>

<script>
/* eslint func-names: ["error", "never"] */
/* eslint object-shorthand: 0 */
export default {
  name: 'ImageControls',
  props: {
    dialog: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    reportUrl() {
      return this.$store.state.project.reportUrl || null;
    },
  },
  methods: {
  },
};
</script>

<style scoped>

.controls-layout {
  background-color: rgba(0, 0, 0, 0.6);
  overflow: hidden;
  border-radius: 5px;
  color: white;
  border-color: grey;
  border-style: solid;
  border-width: thin;
}

</style>
